(() => {
  let opener = null;
  // Closed with a tap or click: focus still goes back to the Size guide button (and to a set
  // piece's copy of it), but without a ring until a key is pressed (owner, 19 Oct). Keyboard users keep it.
  let keyboard = false;
  document.addEventListener('pointerdown', () => { keyboard = false; }, true);
  document.addEventListener('keydown', () => { keyboard = true; document.documentElement.classList.remove('rl-chart-quiet'); }, true);

  function moveSizeChart() {
    const chart = document.querySelector('[data-runit-size-chart]:not([data-runit-chart-library])');
    const slot = document.querySelector('[data-runit-size-chart-slot]');
    if (chart && slot && chart.parentElement !== slot) slot.append(chart);
  }

  function isBackdropClick(dialog, event) {
    const rect = dialog.getBoundingClientRect();
    return (
      event.clientX < rect.left ||
      event.clientX > rect.right ||
      event.clientY < rect.top ||
      event.clientY > rect.bottom
    );
  }

  moveSizeChart();
  document.addEventListener('shopify:section:load', moveSizeChart);

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-runit-chart-open]');
    if (openButton) {
      const dialog = openButton.closest('[data-runit-size-chart]')?.querySelector('dialog');
      if (!dialog) return;
      opener = openButton;
      dialog.showModal();
      document.body.classList.add('runit-dialog-open');
      return;
    }

    const closeButton = event.target.closest('[data-runit-chart-close]');
    if (closeButton) {
      closeButton.closest('dialog')?.close();
      return;
    }

    const dialog = event.target.closest('dialog.runit-size-chart__dialog');
    if (dialog?.open && isBackdropClick(dialog, event)) {
      dialog.close();
    }
  });

  document.addEventListener('close', (event) => {
    if (!event.target.matches?.('dialog.runit-size-chart__dialog')) return;
    document.body.classList.remove('runit-dialog-open');
    document.documentElement.classList.toggle('rl-chart-quiet', !keyboard);
    if (opener) {
      opener.focus();
      opener = null;
    }
  }, true);
})();
